import React from 'react';
import { hasPermission } from '../utils/permissions';

export default function RequirePermission({ userData, permission, children, fallback = null }) {
  if (!userData) return fallback;
  if (!hasPermission(userData, permission)) {
    return fallback || (
      <div className="text-center py-12">
        <h2 className="text-xl font-semibold text-gray-300">Access Denied</h2>
        <p className="text-gray-400 mt-2">You do not have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
